// Route guards enforce access independently of menu visibility.
export function helpPath(user) {
  return user && user.blocked_at === null
    ? '/tickets' : '/feedback';
}

export default function navigation(user, settings = {}, authenticated = false) {
  const item = (title, path, icon) => ({ title, path, icon });
  if (!authenticated) return [];
  if (!user) return [];
  if (user.blocked_at !== null) return [];
  if (!user.is_checked) {
    return [
      item('Личный кабинет', '/dashboard', 'home'),
      item('Личные данные', '/profile', 'user-circle'),
      item('Обращения', helpPath(user), 'question-circle'),
    ];
  }
  const items = [
    item('Личный кабинет', '/dashboard', 'home'),
    item('Профиль', '/profile', 'user-circle'),
    item('Призы', '/prizes', 'gift'),
    item('Заказы', '/orders', 'file-alt'),
  ];
  if (settings.news === true) items.push(item('Новости', '/news', 'comment-dots'));
  if (settings.shop === true) items.push(item('Товары', '/shop', 'shopping-cart'));
  items.push(item('Акции', '/actions', 'percent'));
  if (settings.courses === true) items.push(item('Обучение', '/courses', 'user-graduate'));
  items.push(item('Правила', '/instructions', 'chart-bar'));
  items.push(
    item('Обращения', helpPath(user), 'question-circle'),
  );
  return items;
}

// Desktop navigation follows the original header; the drawer has the full mobile menu.
export function topNavigation(user, settings = {}, authenticated = false) {
  const items = navigation(user, settings, authenticated);
  if (!authenticated || !user) return [];
  if (!user.is_checked) {
    return items.filter(item => item.path !== '/dashboard')
      .map(item => (item.path === '/profile' ? { ...item, title: 'Профиль' } : item));
  }
  if (user.blocked_at !== null) return [];
  const paths = ['/dashboard', '/prizes', '/orders', '/news', '/actions', '/courses', '/instructions', '/shop'];
  return paths.map(path => items.find(item => item.path === path)).filter(Boolean);
}
